import * as Yup from 'yup';

export const validations = Yup.object({
  alias: Yup.string().required('O Cliente/Cidade é obrigatório'),
  accountId: Yup.string().required('O ID da conta é obrigatório')
});